import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.educations.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: 'Enseñanzas artísticas (regladas)', text: $t('data.educations.Enseñanzas artísticas (regladas)', 'Enseñanzas artísticas (regladas)') },
    { value: 'Enseñanzas deportivas (regladas)', text: $t('data.educations.Enseñanzas deportivas (regladas)', 'Enseñanzas deportivas (regladas)') },
    { value: 'Formación Profesional Grado Medio', text: $t('data.educations.Formación Profesional Grado Medio', 'Formación Profesional Grado Medio') },
    { value: 'Ciclo Formativo Grado Medio', text: $t('data.educations.Ciclo Formativo Grado Medio', 'Ciclo Formativo Grado Medio') },
    { value: 'Diplomatura', text: $t('data.educations.Diplomatura', 'Diplomatura') },
    { value: 'Ingeniería Técnica', text: $t('data.educations.Ingeniería Técnica', 'Ingeniería Técnica') },
    { value: 'Grado', text: $t('data.educations.Grado', 'Grado') },
    { value: 'Licenciatura', text: $t('data.educations.Licenciatura', 'Licenciatura') },
    { value: 'Ingeniería Superior', text: $t('data.educations.Ingeniería Superior', 'Ingeniería Superior') },
    { value: 'Postgrado', text: $t('data.educations.Postgrado', 'Postgrado') },
    { value: 'Máster', text: $t('data.educations.Máster', 'Máster') },
    { value: 'Doctorado', text: $t('data.educations.Doctorado', 'Doctorado') }
];
